import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/services/shared/global.service';
import { DutyPaymentsService } from 'src/app/services/payments/duty-payments.service';
import { PendingTasksHandler } from 'src/app/shared/pending-tasks-handler';

@Component({
  selector: 'app-attach-payment-receipt',
  templateUrl: './attach-payment-receipt.component.html',
  styleUrls: ['./attach-payment-receipt.component.css']
})
export class AttachPaymentReceiptComponent implements OnInit{
  public errorMessage: string | null = null;
  public txn_id: string | null = null;
  duty: any;
  bank_accounts:any[] = [];
  form!: FormGroup;
  submitted: boolean = false;
  fileName: string="Choose an image or a PDF file";
  attachment: any;
  isProcessing: boolean = false;

  constructor(
    private activatedRoute:ActivatedRoute, 
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private dutyPaymentsService: DutyPaymentsService,
    private pendingTasksHandler: PendingTasksHandler
    ){
    this.form = this.formBuilder.group({
      attachment: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.txn_id = param['get']('txn_id')
    })

    if(this.txn_id){
      this.getDutyData(this.txn_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }

  }

  /**
   * Get duty details
   * @param txn_id 
   */
  getDutyData(txn_id: string): void {
    this.dutyPaymentsService.getDutyDetails(txn_id)
    .subscribe({
      next: (response) => {
        if(response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{

          this.duty = response;
          
          if(this.duty.status==='no_data' || this.duty.status.length===0){
            this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again.";
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

   /**
   * Handle selectd file
   * @param event 
   */
   onFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.fileName = fileInput.files?.[0]?.name ?? 'Choose an image or a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.attachment = file
    }
  }

  /**
   * Attach payment receipt
   */
  handleSubmit() {
    this.submitted = true;
    
    if (this.form.valid) {
      this.submitted = false;
      this.isProcessing=true;
      
      this.dutyPaymentsService.attachPaymentReceipt(this.attachment,this.txn_id)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing=false;
            this.globalService.setGlobalSuccessMessage(response.message);
            //Count the remaining payments pending receipts attachment
            this.pendingTasksHandler.numberOfPaymentsPendingReceiptsAttachment();
            // Redirect back to duties pending receipt attachments
            this.router.navigate(['paid-duties-pending-attachment']);
          }else if(response.status==='upload_error'){
            this.submitted = false;
            this.isProcessing=false;
            this.globalService.setGlobalWarningMessage(response.message);

            //Redirect back to duties pending receipt attachments
            this.router.navigate(['paid-duties-pending-attachment']);
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.errorMessage=error;
        }
      });
    }
  }

}
